import { font, spacing } from '@chegg-ui/theme'
import styled from 'styled-components'

export const AccordionContainer = styled.div`
  margin-top: ${spacing.px8};
  margin-bottom: ${spacing.px4};
  font-size: ${font.size.px16};
`

export const AccordionHeader = styled.div``

export const AccordionToggleButton = styled.button`
  outline: none;
  background: none;
  margin: 0;
  padding: 0;
  border: none;

  display: flex;
  align-items: center;
  column-gap: ${spacing.px4};
  color: #2e8aee;
`

export const AccordionContent = styled.div`
  margin-top: ${spacing.px12};
  padding: ${spacing.px24} ${spacing.px16};
  background-color: #eff8ff;
  border-radius: ${spacing.px8};
  cursor: default;
`
